// Calculator tab tour steps
import type { TourStep } from './types';

export const CALCULATOR_TOUR: TourStep[] = [
  {
    target: 'body',
    content: 'Welcome to ShreemAstro! Let me guide you through creating your first Vedic astrology chart.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="user-form"]',
    content: 'Start by entering your name, gender, and relationship details.',
    placement: 'right',
  },
  {
    target: '[data-tour="birth-time"]',
    content: 'Enter your birth date and time as accurately as possible. Even a few minutes can change your ascendant (Lagna).',
    placement: 'bottom',
  },
  {
    target: '[data-tour="city-search"]',
    content: 'Search for your birth city. We have 50,000+ Indian cities plus international locations with accurate timezone data.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="save-calculate"]',
    title: 'Generate Your Chart',
    content: 'Click "Save & Calculate" to generate your complete Vedic chart with divisional charts, dashas, and predictions.',
    placement: 'top',
  },
  {
    target: '[data-tour="north-indian-chart"]',
    content: 'Your North Indian style chart will appear here, showing planets in their houses based on the whole-sign house system.',
    placement: 'left',
  },
  {
    target: '[data-tour="vimshottari-dasha"]',
    content: 'The Vimshottari Dasha timeline shows your planetary periods. Current and upcoming dashas are highlighted.',
    placement: 'left',
  },
  {
    target: '[data-tour="shodasha-varga"]',
    content: 'Divisional charts (D1-D60) reveal detailed insights into specific life areas like career (D10), marriage (D9), and more.',
    placement: 'left',
  },
  {
    target: '[data-tour="planet-strength"]',
    content: 'Planet strength metrics (Shadbala, Ishta/Kashta) show which planets can deliver results in your chart.',
    placement: 'left',
  },
];
